import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { GeneratedActivationKey } from "@/types";

// Aktivierungsschluessel generieren. Antwort enthaelt den Klartext-Schluessel — NUR
// hier, danach nie wieder (One-Time-Dialog).
export function useGenerateActivationKey(): UseMutationResult<
  GeneratedActivationKey,
  Error,
  { licenseId: string; ttlSec?: number }
> {
  const { session, logout } = useAuth();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ licenseId, ttlSec }) => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.post<GeneratedActivationKey>(
        `/licenses/${licenseId}/activation-keys`,
        ttlSec === undefined ? {} : { ttlSec },
      );
    },
    onSuccess: (_data, { licenseId }) =>
      qc.invalidateQueries({ queryKey: queryKeys.subResource("licenses", licenseId, "activation-keys") }),
  });
}
